import "./style.css";
import { useSelector } from "react-redux";

const ProjectCard = ({ item }) => {
	const lang = useSelector((state) => state?.lang?.lang);
	return (
		<div className="project-card">
			<img src={item?.image} alt="blog-image" className="blog-image" />
			<div className="details">
				<p
					className="project-title"
					dangerouslySetInnerHTML={{
						__html: item[`title_${lang}`],
					}}></p>
				<p
					className="description"
					dangerouslySetInnerHTML={{
						__html: item[`description_${lang}`],
					}}></p>
				<p className="d-flex mb-0 gap-12 align-items-center">
					<a
						className="time"
						target="_blank"
						href={item?.link}
						rel="noreferrer">
						{item?.link}
					</a>
				</p>
			</div>
		</div>
	);
};
export default ProjectCard;
